export default from './TextMessage';



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/Messages/components/Message/components/TextMessage/index.js